module.exports = "<a href class=\"am4-button am4-button--primary am4-dashboard__scroll-to-top fade\" scroll-to=\"am4-equipment-scroll-top-target\" title=\"{{'SCROLL_TO_TOP' | translate}}\">\n    <i class=\"fa fa-angle-up\"></i>Top\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/equipment/historyFooter.html
// module id = 105
// module chunks = 14